export const formatDateForInput = (dateString: string): string => {
    if (!dateString) return "";
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0"); 
    return `${day}-${month}-${year}`; 
  };
  
  export const validateNumericInput = (value: string): boolean => {
    return value === "" || /^\d+$/.test(value);
  };
  
  export const updateFormDataFromPartSelection = (
    selectedPart: any,
    formData: any
  ) => {
    return {
      ...formData,
      partName: selectedPart.partName,
      model: selectedPart.model,
      category: selectedPart.category,
      invoiceNo: selectedPart.number,
      invoiceDate: formatDateForInput(selectedPart.date),
      qualityOnQty: selectedPart.qty,
      printedQty: selectedPart.printedQty,
      balanceQty: selectedPart.balanceQty,
      packingQty: selectedPart.packingQty,
    };
  };
  
  export const prepareSubmitData = (formData: any, index: number, totalLabels: number) => {
    return {
      grnId: formData.grnNo,
      qty: parseInt(formData.packingQty),
      date: new Date().toISOString(),
      rackId: formData.rack,
      isFirstItem: index === 1,
      updateTable: index === totalLabels
    };
  };